import "./BoundaryErrors.css";

export const MovimientosChartErrorBoundary = ({ children, height = "300px" }) => {
  return (
    <div 
      className="boundary-bg"
      style={{
        width: "100%",
        height: height,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBlock: "1rem 3rem",
        border: "1px solid #e9e8f4",
        borderRadius: "5px",
        boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.1)"
      }}>
        {children}
    </div>
  )
}